module.exports = __webpack_public_path__ + "img/nodata.39502580.png";